import { render } from "./searchField.vue?vue&type=template&id=39fac967&scoped=true"
import script from "./searchField.vue?vue&type=script&lang=js"
export * from "./searchField.vue?vue&type=script&lang=js"

import "./searchField.vue?vue&type=style&index=0&id=39fac967&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39fac967"]])

export default __exports__